import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useHostMutation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation('toggleHostStatus', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: ['hostList'] });
      await revalidate(['hostDetail', 'clubHosts', 'clubBasicInfo', 'all', 'editorRecommendedStores']);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutate: mutateAsync };
};

export default useHostMutation;
